/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IErrorModel } from "../../models";

import * as Consts from "./consts";
import {
  IGetServerTimeAction,
  IGetServerTimeFailureAction,
  IGetServerTimeSuccessAction,
  IGetServerTimeSuccessPayload,
} from "./types";

export const getServerTime = (): IGetServerTimeAction => {
  return {
    type: Consts.GET_SERVER_TIME,
  };
};

export const getServerTimeSuccess = (
  payload: IGetServerTimeSuccessPayload,
): IGetServerTimeSuccessAction => {
  return {
    payload,
    type: Consts.GET_SERVER_TIME_SUCCESS,
  };
};

export const getServerTimeFailure = (
  error?: IErrorModel,
): IGetServerTimeFailureAction => {
  return {
    error,
    type: Consts.GET_SERVER_TIME_FAILURE,
  };
};

export const Actions = {
  getServerTime,
};
